// Mock podatki za Lovsko družino Rakek
// Ti podatki se lahko kasneje nadomestijo z dejanskimi podatki iz baze

export const societyInfo = {
  name: "Lovska družina Rakek",
  nameEn: "Hunting Society Rakek",
  established: 1946,
  foundedPreliminary: 1921,
  members: 81,
  area: 4911.34, // ha - skupna površina
  huntingArea: 4703.30, // ha - lovna površina
  logo: "https://customer-assets.emergentagent.com/job_ld-rakek-web/artifacts/pzckv38a_logo_ld_rakek.jpg",
  email: "ld.rakek@lovskazveza.si",
  phone: "+386 41 350 782",
  address: "Trg padlih borcev 2, 1381 Rakek, Slovenija",
  description: "Lovska družina Rakek je ena najstarejših in z 81 člani ena največjih lovskih organizacij v Zvezi lovskih družin Notranjske. Naša poslanstvo je trajnostno upravljanje z divjadjo in ohranjanje naravnega ravnovesja v naših gozdovih.",
  descriptionEn: "Hunting Society Rakek is one of the oldest and with 81 members one of the largest hunting organizations in the Association of Hunting Societies of Notranjska. Our mission is sustainable wildlife management and preserving the natural balance in our forests."
};

export const history = {
  sl: [
    {
      year: 1921,
      title: "Ustanovitev Lovskega kluba Srnjak Rakek",
      description: "Začetki organiziranega lovstva na Rakeku segajo v leto 1921, ko je bil ustanovljen Lovski klub Srnjak Rakek. To leto velja za začetek organiziranega lovstva na Rakeku."
    },
    {
      year: 1946,
      title: "Ustanovitev Lovske družine Rakek",
      description: "Po drugi svetovni vojni je bila ustanovljena Lovska družina Rakek, ki nadaljuje tradicijo trajnostnega upravljanja z divjadjo."
    },
    {
      year: 1960,
      title: "Otvoritev lovskega doma v Rakovem Škocjanu",
      description: "Odprt je bil nov lovski dom v Rakovem Škocjanu. To je bil pomemben dogodek za družabno življenje in delovanje družine."
    },
    {
      year: 1964,
      title: "Pravilnik o oddajanju lovskega doma",
      description: "Sprejet je bil pravilnik o oddajanju lovskega doma v najem, kar kaže na to, da je bil dom v Rakovem Škocjanu polno funkcionalen in v uporabi."
    },
    {
      year: 1973,
      title: "Prvi odstrel medveda",
      description: "Prvi odstrel medveda v zgodovini Lovske družine Rakek. To je bil prelomen dogodek, saj so bili vsi prejšnji poskusi neuspešni."
    },
    {
      year: 1984,
      title: "Gradnja Lovske koče na Prangerju",
      description: "Začela se je gradnja Lovske koče na Prangerju, ki danes služi kot središče dejavnosti družine."
    },
    {
      year: 1996,
      title: "Prelomno leto - dvojna obletnica",
      description: "Izjemno pomembno leto: 50-letnica ustanovitve Lovske družine Rakek in 75-letnica začetkov organiziranega lovstva na Rakeku. Ob tej priložnosti je izšla obsežna Kronika LD Rakek."
    },
    {
      year: 2009,
      title: "Podelitev koncesij",
      description: "Podelitev koncesij za trajnostno gospodarjenje z divjadjo, kar predstavlja pomemben korak v sodobnem upravljanju lovišča."
    },
    {
      year: 2014,
      title: "Žledolom",
      description: "Žledolom nas je močno prizadel. Na gozdovih in infrastrukturi je naredil veliko škode, ki se kaže še do danes."
    }
  ],
  en: [
    {
      year: 1921,
      title: "Establishment of Hunting Club Srnjak Rakek",
      description: "The beginnings of organized hunting in Rakek date back to 1921, when the Hunting Club Srnjak Rakek was established. This year marks the beginning of organized hunting in Rakek."
    },
    {
      year: 1946,
      title: "Establishment of Hunting Society Rakek",
      description: "After World War II, Hunting Society Rakek was established, continuing the tradition of sustainable wildlife management."
    },
    {
      year: 1960,
      title: "Opening of hunting lodge in Rakov Škocjan",
      description: "A new hunting lodge was opened in Rakov Škocjan. This was an important event for the social life and activities of the society."
    },
    {
      year: 1964,
      title: "Hunting lodge rental regulations",
      description: "Regulations for renting the hunting lodge were adopted, showing that the lodge in Rakov Škocjan was fully functional and in use."
    },
    {
      year: 1973,
      title: "First bear harvest",
      description: "The first bear harvest in the history of Hunting Society Rakek. This was a breakthrough event, as all previous attempts had been unsuccessful."
    },
    {
      year: 1984,
      title: "Construction of hunting lodge at Pranger",
      description: "Construction began on the hunting lodge at Pranger, which today serves as the center of the society's activities."
    },
    {
      year: 1996,
      title: "Landmark year - double anniversary",
      description: "An exceptionally important year: 50th anniversary of Hunting Society Rakek and 75th anniversary of organized hunting in Rakek. On this occasion, the comprehensive Chronicle of LD Rakek was published."
    },
    {
      year: 2009,
      title: "Concession award",
      description: "Award of concessions for sustainable wildlife management, representing an important step in modern hunting ground management."
    },
    {
      year: 2014,
      title: "Ice storm",
      description: "The ice storm severely affected us. It caused great damage to forests and infrastructure, the effects of which are still visible today."
    }
  ]
};

export const huntingArea = {
  sl: {
    title: "Lovišče",
    description: "Naše lovišče obsega 4.911,34 hektarjev skupne površine, od tega 4.703,30 ha lovne površine. Raznolik teren od gostih gozdov do travnikov in mokrišč je dom bogati favni, vključno z jelenjadjo, srnjadjo, divjimi prašiči in številnimi drugimi vrstami.",
    neighbors: [
      { name: "LD Cerknica" },
      { name: "LD Begunje" },
      { name: "LPN Ljubljanski vrh" },
      { name: "LD Logatec" },
      { name: "LD Planina" },
      { name: "LD Javornik Postojna" }
    ],
    wildlife: [
      { name: "Jelenjad", nameEn: "Red Deer" },
      { name: "Srnjad", nameEn: "Roe Deer" },
      { name: "Gams", nameEn: "Chamois" },
      { name: "Medved", nameEn: "Brown Bear" },
      { name: "Volk", nameEn: "Wolf" },
      { name: "Ris", nameEn: "Lynx" },
      { name: "Šakal", nameEn: "Jackal" },
      { name: "Lisica", nameEn: "Fox" },
      { name: "Mala divjad", nameEn: "Small Game" },
      { name: "Ptice", nameEn: "Birds" }
    ]
  },
  en: {
    title: "Hunting Ground",
    description: "Our hunting ground covers 4,911.34 hectares of total area, of which 4,703.30 ha is hunting area. The diverse terrain from dense forests to meadows and wetlands is home to rich fauna, including red deer, roe deer, wild boar, and many other species.",
    neighbors: [
      { name: "LD Cerknica" },
      { name: "LD Begunje" },
      { name: "LPN Ljubljanski vrh" },
      { name: "LD Logatec" },
      { name: "LD Planina" },
      { name: "LD Javornik Postojna" }
    ],
    wildlife: [
      { name: "Red Deer", nameEn: "Red Deer" },
      { name: "Roe Deer", nameEn: "Roe Deer" },
      { name: "Chamois", nameEn: "Chamois" },
      { name: "Brown Bear", nameEn: "Brown Bear" },
      { name: "Wolf", nameEn: "Wolf" },
      { name: "Lynx", nameEn: "Lynx" },
      { name: "Jackal", nameEn: "Jackal" },
      { name: "Fox", nameEn: "Fox" },
      { name: "Small Game", nameEn: "Small Game" },
      { name: "Birds", nameEn: "Birds" }
    ]
  }
};

export const leadership = [
  {
    name: "Aleš Gorkič",
    role: { sl: "Predsednik", en: "Chairman" },
    phone: "041 350 782",
    image: null
  },
  {
    name: "Matjaž Urbas",
    role: { sl: "Gospodar", en: "Game Warden" },
    phone: "031 290 415",
    image: null
  },
  {
    name: "Žan Zidar",
    role: { sl: "Tajnik", en: "Secretary" },
    phone: "041 986 111",
    image: null
  },
  {
    name: "Anton Udovič",
    role: { sl: "Blagajnik", en: "Treasurer" },
    phone: "041 688 670",
    image: null
  },
  {
    name: "Valter Ivančič",
    role: { sl: "Referent za ocenjevanje škode po divjadi", en: "Wildlife Damage Assessment Officer" },
    phone: "031 647 346",
    image: null
  },
  {
    name: "Franc Meden",
    role: { sl: "Upravnik lovske koče Pranger", en: "Pranger Lodge Manager" },
    phone: "031 370 741",
    image: null
  },
  {
    name: "Janez Steržaj",
    role: { sl: "Upravnik lovske koče Rakov Škocjan", en: "Rakov Škocjan Lodge Manager" },
    phone: "041 832 187",
    image: null
  }
];

export const lodges = [
  {
    id: "pranger",
    name: { sl: "Lovska koča Pranger", en: "Pranger Hunting Lodge" },
    description: {
      sl: "Lovska koča na Prangerju je sodobno opremljena koča, ki služi kot središče dejavnosti Lovske družine Rakek. Primerna za različne prireditve in druženja.",
      en: "The Pranger Hunting Lodge is a modernly equipped lodge that serves as the center of activities for the Hunting Society Rakek. Suitable for various events and gatherings."
    },
    manager: "Franc Meden",
    phone: "031 370 741",
    image: "https://images.unsplash.com/photo-1449158743715-0a90ebb6d2d8?w=800&h=500&fit=crop"
  },
  {
    id: "rakov-skocjan",
    name: { sl: "Lovska koča Rakov Škocjan", en: "Rakov Škocjan Hunting Lodge" },
    description: {
      sl: "Zgodovinska lovska koča v Rakovem Škocjanu, odprta leta 1960. Nahaja se v bližini naravnega rezervata Rakov Škocjan z znamenitim naravnim mostom.",
      en: "Historic hunting lodge in Rakov Škocjan, opened in 1960. Located near the Rakov Škocjan nature reserve with its famous natural bridge."
    },
    manager: "Janez Steržaj",
    phone: "041 832 187",
    image: "https://images.unsplash.com/photo-1510798831971-661eb04b3739?w=800&h=500&fit=crop"
  }
];

export const gallery = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1586114539347-827507d2f006?w=800&h=600&fit=crop",
    alt: { sl: "Kraška pokrajina Notranjske", en: "Karst landscape of Notranjska" },
    category: "nature"
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1571145566507-741ae98d4bf5?w=800&h=600&fit=crop",
    alt: { sl: "Jelen - jelenjad", en: "Red deer stag" },
    category: "wildlife"
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1567339729865-ecb5dc18f051?w=800&h=600&fit=crop",
    alt: { sl: "Zelena dolina", en: "Green valley" },
    category: "nature"
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1599948058228-9dd8274b4c93?w=800&h=600&fit=crop",
    alt: { sl: "Rjavi medved", en: "Brown bear" },
    category: "wildlife"
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1604950299426-70dae59db756?w=800&h=600&fit=crop",
    alt: { sl: "Jesenski gozd", en: "Autumn forest" },
    category: "nature"
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1653905238374-80f0a6ebbae3?w=800&h=600&fit=crop",
    alt: { sl: "Volk", en: "Wolf" },
    category: "wildlife"
  },
  {
    id: 7,
    src: "https://images.unsplash.com/photo-1735857999392-92e8bbab6c2c?w=800&h=600&fit=crop",
    alt: { sl: "Gost gozd", en: "Dense forest" },
    category: "nature"
  },
  {
    id: 8,
    src: "https://images.unsplash.com/photo-1692626972586-5333392e45f5?w=800&h=600&fit=crop",
    alt: { sl: "Gams ob sončnem vzhodu", en: "Chamois at sunrise" },
    category: "wildlife"
  },
  {
    id: 9,
    src: "https://images.unsplash.com/photo-1567624241640-3b7194483727?w=800&h=600&fit=crop",
    alt: { sl: "Gams na skali", en: "Chamois on rock" },
    category: "wildlife"
  }
];

export const news = [
  {
    id: 1,
    title: { sl: "Letni občni zbor", en: "Annual General Meeting" },
    date: "2025-03-15",
    excerpt: {
      sl: "Vabimo vse člane na letni občni zbor, ki bo v soboto, 15. marca 2025, ob 17:00 v lovski koči.",
      en: "We invite all members to the annual general meeting on Saturday, March 15, 2025, at 5:00 PM in the hunting lodge."
    },
    content: {
      sl: "Vabimo vse člane na letni občni zbor, ki bo v soboto, 15. marca 2025, ob 17:00 v lovski koči. Na dnevnem redu bodo poročila o preteklem letu, finančno poročilo in načrti za prihodnje obdobje.",
      en: "We invite all members to the annual general meeting on Saturday, March 15, 2025, at 5:00 PM in the hunting lodge. The agenda includes reports on the past year, financial report, and plans for the upcoming period."
    },
    category: "event"
  },
  {
    id: 2,
    title: { sl: "Uspešna sezona", en: "Successful Season" },
    date: "2025-02-20",
    excerpt: {
      sl: "Lovska sezona 2024/2025 je bila uspešno zaključena. Zahvaljujemo se vsem članom za njihov prispevek.",
      en: "The 2024/2025 hunting season has been successfully concluded. We thank all members for their contribution."
    },
    content: {
      sl: "Lovska sezona 2024/2025 je bila uspešno zaključena. Izpolnili smo vse predpisane kvote in prispevali k zdravemu stanju populacij divjadi. Zahvaljujemo se vsem članom za njihov prispevek k trajnostnemu lovstvu.",
      en: "The 2024/2025 hunting season has been successfully concluded. We have fulfilled all prescribed quotas and contributed to healthy wildlife populations. We thank all members for their contribution to sustainable hunting."
    },
    category: "news"
  },
  {
    id: 3,
    title: { sl: "Delavna akcija - čiščenje lovišča", en: "Work Action - Hunting Ground Cleanup" },
    date: "2025-04-05",
    excerpt: {
      sl: "V soboto, 5. aprila, organiziramo delavno akcijo čiščenja lovišča. Zbiramo se ob 8:00 pri lovski koči.",
      en: "On Saturday, April 5, we are organizing a hunting ground cleanup action. Meeting at 8:00 AM at the hunting lodge."
    },
    content: {
      sl: "V soboto, 5. aprila, organiziramo delavno akcijo čiščenja lovišča. Zbiramo se ob 8:00 pri lovski koči. Prosimo, da prinesete primerno orodje in oblačila. Po akciji sledi družabno srečanje.",
      en: "On Saturday, April 5, we are organizing a hunting ground cleanup action. Meeting at 8:00 AM at the hunting lodge. Please bring appropriate tools and clothing. A social gathering will follow the action."
    },
    category: "event"
  }
];

export const translations = {
  sl: {
    nav: {
      home: "Domov",
      about: "O nas",
      history: "Zgodovina",
      area: "Lovišče",
      leadership: "Kontakti",
      lodges: "Lovske koče",
      gallery: "Galerija",
      news: "Novice",
      contact: "Kontakt"
    },
    hero: {
      title: "Lovska družina Rakek",
      subtitle: "S spoštovanjem do divjadi, z odgovornostjo do narave.",
      cta: "Spoznajte nas"
    },
    about: {
      title: "O nas",
      established: "Ustanovljeni",
      members: "Članov",
      area: "Površina lovišča"
    },
    history: {
      title: "Zgodovina na kratko"
    },
    huntingArea: {
      title: "Naše lovišče",
      wildlife: "Divjad v našem lovišču",
      neighbors: "Mejna lovišča"
    },
    leadership: {
      title: "Kontakti",
      since: "Od leta"
    },
    lodges: {
      title: "Lovske koče",
      pranger: "Lovska koča Pranger",
      rakovSkocjan: "Lovska koča Rakov Škocjan"
    },
    gallery: {
      title: "Galerija",
      all: "Vse",
      nature: "Narava",
      wildlife: "Divjad"
    },
    news: {
      title: "Novice in obvestila",
      readMore: "Preberi več",
      event: "Dogodek",
      newsLabel: "Novica"
    },
    contact: {
      title: "Kontakt",
      address: "Naslov",
      phone: "Telefon",
      email: "E-pošta",
      sendMessage: "Pošljite sporočilo",
      name: "Ime",
      message: "Sporočilo",
      send: "Pošlji"
    },
    footer: {
      rights: "Vse pravice pridržane.",
      privacy: "Zasebnost",
      terms: "Pogoji uporabe"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      history: "History",
      area: "Hunting Area",
      leadership: "Contacts",
      lodges: "Hunting Lodges",
      gallery: "Gallery",
      news: "News",
      contact: "Contact"
    },
    hero: {
      title: "Hunting Society Rakek",
      subtitle: "With respect for wildlife, with responsibility for nature.",
      cta: "Learn More"
    },
    about: {
      title: "About Us",
      established: "Established",
      members: "Members",
      area: "Hunting Area"
    },
    history: {
      title: "History in Brief"
    },
    huntingArea: {
      title: "Our Hunting Ground",
      wildlife: "Wildlife in Our Area",
      neighbors: "Neighboring Hunting Grounds"
    },
    leadership: {
      title: "Contacts",
      since: "Since"
    },
    lodges: {
      title: "Hunting Lodges",
      pranger: "Pranger Hunting Lodge",
      rakovSkocjan: "Rakov Škocjan Hunting Lodge"
    },
    gallery: {
      title: "Gallery",
      all: "All",
      nature: "Nature",
      wildlife: "Wildlife"
    },
    news: {
      title: "News & Announcements",
      readMore: "Read more",
      event: "Event",
      newsLabel: "News"
    },
    contact: {
      title: "Contact",
      address: "Address",
      phone: "Phone",
      email: "Email",
      sendMessage: "Send a Message",
      name: "Name",
      message: "Message",
      send: "Send"
    },
    footer: {
      rights: "All rights reserved.",
      privacy: "Privacy",
      terms: "Terms of Use"
    }
  }
};
